import type { PageGuide } from "../page-guide.js";

export const engagementPlanGuide: PageGuide = {
  route: "/engagement-plan",
  version: 1,
  overviewArticleId: "engagement-plan-overview",
  steps: [
    {
      id: "choose-partner",
      title: "Choose the partner",
      body: "Confirm the active **Partner** before editing or publishing. The client view and all share candidates follow this tenant.",
      anchorId: "engagement-partner-selector",
    },
    {
      id: "readiness",
      title: "Complete portal readiness",
      body: "Work through **Invite → Brief → Share**, then inspect **Client view** before anything is sent.",
      anchorId: "engagement-workspace",
    },
    {
      id: "publish",
      title: "Preview, confirm, publish",
      body: "In **Share**, select an object and publish it. Ask Insights can list candidates and preview the exact target; every write still requires your confirmation.",
      anchorId: "engagement-workspace",
    },
  ],
  panels: [
    {
      anchorId: "engagement-partner-selector",
      title: "Partner and engagement",
      body: "Publishing is always scoped to the selected partner and engagement.",
      relatedArticleId: "engagement-plan-overview",
    },
    {
      anchorId: "engagement-workspace",
      title: "Client Hub workspace",
      body: "Use Brief, Plan, Share, and Collaborate; keep Client view open to verify what the client will see.",
      relatedArticleId: "engagement-plan-overview",
    },
  ],
  guidedActions: [],
};
